import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="judge-type-toggle"
export default class extends Controller {
  static targets = ["checkbox"]
  static values = {
    section: String
  }

  connect() {
    // Инициализируем состояние при загрузке страницы
    this.toggle()

    // Добавляем обработчик изменения для чекбокса
    this.checkboxTarget.addEventListener('change', () => {
      this.toggle()
    })
  }

  toggle() {
    const section = document.querySelector(this.sectionValue)
    if (section && this.hasCheckboxTarget) {
      if (this.checkboxTarget.checked) {
        section.classList.remove('d-none')
      } else {
        section.classList.add('d-none')
      }
    }
  }
}
